import { render, staticRenderFns } from "./UploadPhotoArea.vue?vue&type=template&id=43e3c7be&"
import script from "./UploadPhotoArea.vue?vue&type=script&lang=js&"
export * from "./UploadPhotoArea.vue?vue&type=script&lang=js&"
import style0 from "./UploadPhotoArea.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43e3c7be')) {
      api.createRecord('43e3c7be', component.options)
    } else {
      api.reload('43e3c7be', component.options)
    }
    module.hot.accept("./UploadPhotoArea.vue?vue&type=template&id=43e3c7be&", function () {
      api.rerender('43e3c7be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/controls/UploadPhotoArea.vue"
export default component.exports